/* Ryedical — shared empty-cart offer behaviour.
   Powers the tier radios + Add to cart button rendered by
   snippets/ryedical-empty-cart-offer.liquid, in both the /cart page empty
   state and the cart drawer empty state.

   Uses event delegation on `document` (NOT inline <script>) so it keeps
   working after the cart drawer dynamically re-renders to its empty state
   when the last item is removed — inline scripts injected via innerHTML
   do not execute. */
(function () {
  'use strict';

  function root() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function selectedRadio(offer) {
    return offer.querySelector('[data-ry-empty-radio]:checked');
  }

  function syncCta(offer) {
    var radio = selectedRadio(offer);
    var cta = offer.querySelector('[data-ry-empty-cta]');
    if (!radio || !cta || cta.disabled) return;
    cta.textContent = radio.getAttribute('data-cta-text') || 'Add to cart';
  }

  /* Tier change → update selected styling + CTA label */
  document.addEventListener('change', function (e) {
    var radio = e.target.closest ? e.target.closest('[data-ry-empty-radio]') : null;
    if (!radio) return;
    var offer = radio.closest('[data-ry-empty-offer]');
    if (!offer) return;

    offer.querySelectorAll('[data-ry-empty-opt]').forEach(function (o) {
      o.classList.remove('is-selected');
    });
    var opt = radio.closest('[data-ry-empty-opt]');
    if (opt) opt.classList.add('is-selected');

    syncCta(offer);
  });

  /* Add to cart → AJAX add, then open/refresh the cart drawer */
  document.addEventListener('click', function (e) {
    var cta = e.target.closest ? e.target.closest('[data-ry-empty-cta]') : null;
    if (!cta) return;
    var offer = cta.closest('[data-ry-empty-offer]');
    if (!offer) return;

    var radio = selectedRadio(offer);
    if (!radio) return;
    var variantId = radio.getAttribute('data-variant-id');
    var sellingPlan = radio.getAttribute('data-selling-plan');
    if (!variantId) return;

    e.preventDefault();
    var originalText = cta.textContent;
    cta.disabled = true;
    cta.textContent = 'Adding…';

    var cartElement = document.querySelector('cart-drawer') || document.querySelector('cart-notification');

    var formData = new FormData();
    formData.append('id', variantId);
    formData.append('quantity', '1');
    if (sellingPlan) formData.append('selling_plan', sellingPlan);

    if (cartElement && typeof cartElement.getSectionsToRender === 'function') {
      formData.append(
        'sections',
        cartElement.getSectionsToRender().map(function (s) { return s.id; }).join(',')
      );
      formData.append('sections_url', window.location.pathname);
      if (typeof cartElement.setActiveElement === 'function') {
        cartElement.setActiveElement(document.activeElement);
      }
    }

    fetch(root() + 'cart/add.js', {
      method: 'POST',
      headers: { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/javascript' },
      body: formData
    })
      .then(function (res) { return res.json(); })
      .then(function (response) {
        cta.disabled = false;
        cta.textContent = originalText;
        if (response.status) {
          console.error('Ryedical empty-cart add error:', response.description || response.message);
          return;
        }
        if (cartElement && typeof cartElement.renderContents === 'function') {
          if (cartElement.classList.contains('is-empty')) {
            cartElement.classList.remove('is-empty');
          }
          // renderContents swaps the drawer DOM and opens it (Taste cart-drawer).
          cartElement.renderContents(response);
        } else {
          window.location = root() + 'cart';
        }
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: 'ryedical-empty-cart',
            productVariantId: variantId,
            cartData: response
          });
        }
      })
      .catch(function (err) {
        cta.disabled = false;
        cta.textContent = originalText;
        console.error('Ryedical empty-cart add failed:', err);
      });
  });
})();
